import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MessageDialogComponent } from './message-dialog/message-dialog.component';
import { FormsModule } from '@angular/forms';




@NgModule({
  declarations: [
    MessageDialogComponent
  ],
  imports: [
    CommonModule,
    FormsModule
  ],
  exports: [MessageDialogComponent]
})
export class CoreModule { }
